import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../../services';
import { AsyncPipe } from '@angular/common';
import { TranslationService } from '../../../services/translation.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'user-inner',
  imports: [RouterLink, AsyncPipe,TranslatePipe],
  templateUrl: './user-inner.component.html',
  styleUrl: './user-inner.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'hidden absolute top-[3.25rem] right-0 w-72 p-4 bg-surface-0 border border-surface rounded-border origin-top shadow-[0px_3px_5px_rgba(0,0,0,0.02),0px_0px_2px_rgba(0,0,0,0.05),0px_1px_4px_rgba(0,0,0,0.08)]',
  },
})
export class UserInnerComponent {
  authService = inject(AuthService);
  translateService=inject(TranslationService)


  logout() {
    this.authService.logout(null);
  }
}
